module.exports = __webpack_public_path__ + "img/10.89ad18c7.svg";